/* Hero media carousel — product photo + unboxing/using video.
   - Product photo is the default slide (keeps it the fast LCP).
   - Dots / arrows / keyboard switch slides.
   - Auto-advances to the video after 5s of NO interaction; the video then
     muted-autoplays and loops. Tap the video for sound + native controls.
   - Any interaction (dot, arrow, play, tap, keyboard) cancels the auto-advance.
   - Progressive enhancement: if JS fails, the product photo still shows. */
(function () {
  var media = document.getElementById('heroMedia');
  if (!media) return;
  var track = document.getElementById('heroTrack');
  var slides = track.children;
  var dots = media.querySelectorAll('.hero__dot');
  var video = document.getElementById('heroVideo');
  var playBtn = document.getElementById('heroPlayBtn');
  var n = slides.length;
  var cur = 0;
  var interacted = false;
  var autoTimer = null;

  function isVideoSlide(i) {
    return slides[i] && slides[i].classList.contains('hero__slide--video');
  }

  function startMuted() {
    if (!video) return;
    video.muted = true;
    media.classList.add('is-playing');            // optimistic: hide the play button (no flash)
    var p = video.play();
    if (p && p.catch) p.catch(function () { media.classList.remove('is-playing'); });
  }

  function go(i) {
    i = (i + n) % n;
    cur = i;
    track.style.transform = 'translateX(' + (-i * 100) + '%)';
    for (var d = 0; d < dots.length; d++) {
      var on = d === i;
      dots[d].classList.toggle('is-on', on);
      dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    var onVideo = isVideoSlide(i);
    media.classList.toggle('is-video', onVideo);
    if (onVideo) {
      startMuted();
    } else if (video) {
      video.pause();
      video.controls = false;
      video.muted = true;
      media.classList.remove('is-playing');
    }
  }

  function stopAuto() { if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; } }
  function markInteracted() { interacted = true; stopAuto(); }

  for (var d = 0; d < dots.length; d++) {
    (function (idx) { dots[idx].addEventListener('click', function () { markInteracted(); go(idx); }); })(d);
  }
  var prev = media.querySelector('.hero__cnav--prev');
  var next = media.querySelector('.hero__cnav--next');
  if (prev) prev.addEventListener('click', function () { markInteracted(); go(cur - 1); });
  if (next) next.addEventListener('click', function () { markInteracted(); go(cur + 1); });

  // Play WITH sound — used when the user taps the play button
  // (visible when muted autoplay was blocked, or before it starts).
  if (playBtn) playBtn.addEventListener('click', function () {
    markInteracted();
    if (!video) return;
    video.muted = false;
    video.controls = true;
    media.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  });

  // Tap the muted-playing video → unmute + native controls.
  if (video) video.addEventListener('click', function () {
    markInteracted();
    if (video.muted) { video.muted = false; video.controls = true; }
  });

  media.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { markInteracted(); go(cur - 1); }
    else if (e.key === 'ArrowRight') { markInteracted(); go(cur + 1); }
  });

  // Start the 5s countdown only once the hero media is actually on screen
  // (it lives behind the quiz gate on the live page).
  function startCountdown() {
    if (interacted || autoTimer) return;
    autoTimer = setTimeout(function () {
      autoTimer = null;
      if (!interacted && cur === 0) go(1);
    }, 5000);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) { startCountdown(); io.disconnect(); break; }
      }
    }, { threshold: 0.5 });
    io.observe(media);
  } else {
    startCountdown();
  }
})();

/* Hero facts accordion — Key facts / Perfect for, collapsible under the body.
   Self-contained (own classes) so it never collides with the FAQ's quiz.js handler. */
(function () {
  var heads = document.querySelectorAll('.hero__acc-h');
  for (var i = 0; i < heads.length; i++) {
    (function (h) {
      h.addEventListener('click', function () {
        var open = h.parentElement.classList.toggle('open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    })(heads[i]);
  }
})();
